import InfoLabel from "./InfoLabel";

export default InfoLabel;
